module.exports = __webpack_public_path__ + "img/value-blocks-slider-cjdr.79af8abe.png";